const $leadGenerationModal = $('.lead-generation--modal');
const $openModal = $('.lead-generation__cta__open');
const $hideBar = $('.lead-generation__cta__close');
const $hideModal = $('.js-lead-generation-button--close');
const $submit = $('.lead-generation__send-button');
const $leadGenerationBar = $('.js-lead-generation--bar');

const $checkboxLegal = $('.js-lead-generation-gdpr');

const $leadGenerationForm = $('.lead-generation__form');
const $leadGenerationFormSuccess = $('.lead-generation__form--success');

const openLeadGenerationModal = () => {
    $leadGenerationModal.addClass('lead-generation--visible');
    closeLeadGenerationBar();
};

const closeLeadGenerationBar = () => {
    $leadGenerationBar.addClass('hide');
}

const closeLeadGenerationModal = () => {
    $leadGenerationModal.removeClass('lead-generation--visible');
}

const setLegalCheckbox = () => {
    const checkBoxes = $('.lead-generation__gdpr');
    checkBoxes.prop("checked", !checkBoxes.prop("checked"));
}

const sendForm = () => {

    const leadGenerationData = {
        email: $('.lead-generation__email').val(),
        info: $('.lead-generation__textarea').val(),
        lang: $('.lead-generation__lang').attr("data-lang")
    }

    $.ajax( {
        type : 'POST',
        url : '/api/mailfeedback/leadgeneration',
        data : JSON.stringify(leadGenerationData),
        contentType : 'application/json; charset=utf-8',
        dataType : 'json',

        success : function ( data ) {
            console.log( data );
            $leadGenerationForm.hide();
            $leadGenerationFormSuccess.show();
        }, 

        error : function ( errorMsg ) {
            console.log( errorMsg );
        },

        failure : function ( failureMsg ) {
            console.log( failureMsg );
        }
   }) 
}

const events = () => {
    $checkboxLegal.on('click', setLegalCheckbox);

    $openModal.on( 'click', openLeadGenerationModal);
    $hideModal.on( 'click', closeLeadGenerationModal);
    $hideBar.on( 'click', closeLeadGenerationBar)

    $submit.on('click', sendForm);

    if ($leadGenerationBar.length) {
        $(window).on('load', function() {
            setTimeout(() => {
                $leadGenerationBar.toggle("slow");
            }, 10000);
        });
    }
};

const init = () => {
	events(); 
};

export default init;
